export class RenderLog {

    static debugLogging = false

    public static track(componentId: string) {
        if (this.debugLogging) console.log(`Render: ${componentId}`)
    }
}